import ModalWindow from "components/ModalWindow";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createAPI } from "services/api/api";
import CraftBlockPredictionCombineList from "./CraftBlockPredictionCombineList";
import CraftBlockPredictionCombineLoader from "./CraftBlockPredictionCombineLoader";
import { setRefreshTrigger } from "store/cards";
import { CraftPredictionContext } from "pages/CraftPrediction";

const CraftBlockPredictionCombineWindow = ({ close }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [isSendCombine, setIsSendCombine] = useState(false)
  const [items, setItems] = useState([]);
  const [offsetCount, setOffsetCount] = useState(0);
  const {refreshTrigger} = useSelector((state) => state.cards);
  const [selectedPrizes, setSelectedPrizes] = useState([]);

  const {selectItemHandler} = useContext(CraftPredictionContext);
  const api = createAPI();

  const { id } = useSelector((state) => state.crafting.prediction[0].value);

  const currentSum = selectedPrizes.reduce((sum, item) => sum + item.cost, 0)

  const isDisabledSubmit = selectedPrizes.length < 2 || isSendCombine || currentSum > 50;

  const combineHandler = (e) => {
    setIsSendCombine(true)
    const selectedIds = selectedPrizes.map((prize) => prize.id);
    const payload = { ids: selectedIds };

    api
      .post(`/prize/combined_prize`, payload)
      .then((response) => {
        setSelectedPrizes([]);
        dispatch(setRefreshTrigger())
        selectItemHandler(response.data.data[0]);
        close(e);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchData = () => {
    api
      .get(
        `me/nft_card_prize/params?&limit=30&offset=${offsetCount}&order=low_high&identity_id=${id}`
      )
      .then((response) => {
        setItems([...items, ...response.data.data]);
        setIsLoading(false);
      })
      .catch((e) => console.log(`Can't fetch prize cards`, e));
  };

  useEffect(() => {
    fetchData();
  }, [refreshTrigger, offsetCount]);

  return (
    <ModalWindow close={close}>
      <div
        className="modal-window__wrapper modal-window__wrapper--combine-prizes"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="modal-window__title">Combine Prize Cards</h2>
        <p className="modal-window__additional">
          Select two or more prize cards to combine into a single card. The new
          prize card value will be the sum of the combined cards.
        </p>
        {isLoading ? (
          <CraftBlockPredictionCombineLoader />
        ) : (
          <CraftBlockPredictionCombineList
            items={items}
            selectedPrizes={selectedPrizes}
            setSelectedPrizes={setSelectedPrizes}
            setOffsetCount={setOffsetCount}
          />
        )}

        <footer className="modal-window__footer">
          <span className="craft-block__tip">
            $50 is Maximum Prize Card Combination
          </span>
          <button className="modal-window__footer-close" type="button" onClick={(e) => close(e)}>
            Cancel
          </button>
          <button
            className="modal-window__footer-submit"
            type="button"
            disabled={isDisabledSubmit}
            onClick={(e) => combineHandler(e)}
          >
            Combine {(selectedPrizes.length >= 2 && !isLoading) && <>({selectedPrizes.length}) - <span>${currentSum}</span></>}
          </button>
        </footer>
      </div>
    </ModalWindow>
  );
};

export default CraftBlockPredictionCombineWindow;
